import { TableCell } from '@shadcn/components/table';
import styled from 'styled-components';

export const GenericCell = styled.div`
  color: darkslategray;
  padding: 8px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  align-self: flex-start;
  width: fit-content;
  min-width: 28px;
`;

export const CorrectChoice = styled(GenericCell)`
  background-color: hsl(var(--rag-green));
  color: white;
`;

export const PartiallyCorrectChoice = styled(GenericCell)`
  background-color: hsl(var(--rag-amber));
  color: white;
`;

export const IncorrectChoice = styled(GenericCell)`
  background-color: hsl(var(--rag-red));
  color: white;
`;

export const OtherOption = styled(GenericCell)`
  border: 1px solid lightgray;
`;

export const OtherOptionsCell = styled(TableCell)`
  display: flex;
  gap: 0.4em;
`;
